import { generatePath, useParams } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import type { ParamParseKey } from "react-router";

export const useConfirmParams = () => {
	const { hotelID, langCode } = useParams<ParamParseKey<typeof PATHS.HOTEL.HOTEL_SETTINGS.MAIL_SETTINGS.I18N>>();

	if (!hotelID || !langCode) {
		throw Error("error");
	}

	const navigator = {
		default: generatePath(PATHS.HOTEL.HOTEL_SETTINGS.MAIL_SETTINGS.TOP, { hotelID }),
		i18n: (langCode: LangCode) =>
			generatePath(PATHS.HOTEL.HOTEL_SETTINGS.MAIL_SETTINGS.I18N, { hotelID, langCode }),
	};

	const activeLangCode = langCode as LangCode;

	return {
		hotelID,
		navigator,
		langCode: activeLangCode,
	};
};
